/**
 * @fileoverview Flag "welcome-seen" — controla se a WelcomeScreen
 * deve aparecer.
 *
 * Welcome aparece SÓ na 1ª abertura do app naquele device. Setado
 * quando user clica qualquer CTA da Welcome (incluindo Settings
 * atalho — significa que user já interagiu com a tela e não precisa
 * vê-la de novo).
 *
 * **Não associado a conta** — é por device. User pode ter múltiplas
 * contas/perfis no mesmo device, mas Welcome aparece 1×. `Hard Reset`
 * via Settings limpa tudo (`localStorage.clear()`), incluindo essa flag
 * — Welcome aparece de novo.
 */

const KEY = 'iptv:welcome-seen'

export function hasSeenWelcome(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true'
  } catch {
    // Privacy mode / quota cheia / plataforma sem suporte: assume não
    // viu (mostra Welcome). Mais seguro do que pular Welcome em casos
    // edge.
    return false
  }
}

export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(KEY, 'true')
  } catch {
    // Falha silenciosa — Welcome aparecerá de novo no próximo boot.
    // UX degradada mas não-quebrada.
  }
}

/** Limpa flag — Welcome volta a aparecer na próxima abertura. Hoje
 *  Hard Reset (Settings) usa `localStorage.clear()` global que cobre
 *  isso. Função existe por completude da API caso evolução futura
 *  precise reset granular. */
export function clearWelcomeSeen(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // idem
  }
}
